import { Search, ArrowRight, Shuffle } from "lucide-react";
import { CATEGORIES } from "@/constants/brand";

export function SearchPanel({
    value,
    onChange,
    onSubmit,
    onCategory,
    onSurprise,
    compact = false,
}) {
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(value);
    };

    return (
        <div className="w-full">
            <form
                onSubmit={handleSubmit}
                role="search"
                className="w-full"
                data-testid="search-form"
            >
                <label htmlFor="ck-search" className="sr-only">
                    Search CaprioKnows
                </label>
                <div
                    className="group flex items-center gap-3 rounded-full bg-white pl-5 pr-2 py-2 transition-shadow duration-200 shadow-[0_2px_24px_-8px_rgba(84,33,154,0.25)] focus-within:shadow-[0_8px_40px_-10px_rgba(84,33,154,0.45)]"
                    style={{ border: "1px solid var(--ck-border)" }}
                >
                    <Search
                        className="shrink-0"
                        size={compact ? 20 : 24}
                        style={{ color: "var(--ck-royal)" }}
                        aria-hidden="true"
                    />
                    <input
                        id="ck-search"
                        data-testid="search-input"
                        type="text"
                        autoComplete="off"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        placeholder="What do you want to know?"
                        className={`flex-1 bg-transparent border-0 outline-none placeholder:text-neutral-400 text-charcoal ${
                            compact ? "text-base py-1" : "text-lg py-2"
                        }`}
                        style={{ color: "var(--ck-charcoal)" }}
                    />
                    <button
                        type="submit"
                        data-testid="search-submit"
                        aria-label="Search"
                        className="shrink-0 rounded-full p-2.5 text-white transition-transform duration-150 hover:scale-105 active:scale-95"
                        style={{ backgroundColor: "var(--ck-royal)" }}
                    >
                        <ArrowRight size={compact ? 18 : 20} aria-hidden="true" />
                    </button>
                </div>
            </form>

            {!compact && (
                <>
                    <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
                        <button
                            type="button"
                            data-testid="caprio-knows-btn"
                            onClick={() => onSubmit(value)}
                            className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-white transition-all duration-150 hover:scale-[1.03] active:scale-95"
                            style={{ backgroundColor: "var(--ck-royal)" }}
                        >
                            Caprio Knows
                            <ArrowRight size={16} aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            data-testid="surprise-me-btn"
                            onClick={onSurprise}
                            className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-all duration-150 hover:scale-[1.03] active:scale-95"
                            style={{
                                backgroundColor: "#f3eef8",
                                color: "var(--ck-charcoal)",
                                border: "1px solid var(--ck-border)",
                            }}
                        >
                            Surprise Me
                            <Shuffle size={16} aria-hidden="true" />
                        </button>
                    </div>

                    <div className="mt-5 flex flex-wrap items-center justify-center gap-2.5">
                        {CATEGORIES.map((c) => (
                            <button
                                key={c.label}
                                type="button"
                                data-testid={`category-${c.label.toLowerCase()}`}
                                onClick={() => onCategory(c.query, c.label)}
                                className="rounded-full px-4 py-2 text-sm font-medium transition-colors duration-150"
                                style={{
                                    color: "var(--ck-charcoal)",
                                    backgroundColor: "#fff",
                                    border: "1px solid var(--ck-border)",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                        "var(--ck-royal)";
                                    e.currentTarget.style.color = "#fff";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                        "#fff";
                                    e.currentTarget.style.color =
                                        "var(--ck-charcoal)";
                                }}
                            >
                                {c.label}
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
